import { animate, animation, style } from '@angular/animations';

export const slideIn = animation(
  [
    style({
      opacity: 0,
      transform: '{{ translateX }}',
    }),
    animate(
      '{{ time }}',
      style({
        opacity: 1,
        transform: 'translateX(0)',
      }),
    ),
  ],
  { params: { time: '200ms ease-in', translateX: 'translateX(10%)' } },
);

export const slideOut = animation(
  [
    style({
      opacity: 1,
      transform: 'translateX(0)',
    }),
    animate(
      '{{ time }}',
      style({
        opacity: 0,
        transform: '{{ translateX }}',
      }),
    ),
  ],
  { params: { time: '200ms ease-in', translateX: 'translateX(10%)' } },
);

export const fadeIn = animation(
  [
    style({
      opacity: 0,
    }),
    animate(
      '{{ time }}',
      style({
        opacity: 1,
      }),
    ),
  ],
  { params: { time: '200ms' } },
);

export const fadeOut = animation(
  [
    style({
      opacity: 1,
    }),
    animate(
      '{{ time }}',
      style({
        opacity: 0,
      }),
    ),
  ],
  { params: { time: '200ms' } },
);
